import type { ApiQueryParams } from "@/types/api-types";

export type TicketSorting =
  | "unread"
  | "newest"
  | "oldest"
  | "leastRecentActivity"
  | "mostRecentActivity"
  | "mostRecentReminder"
  | undefined;

export type AdminTicketTabs = Exclude<ApiQueryParams<"getAdminTicketsV1">["Tab"], undefined>;
export type ResidentTicketTabs = Exclude<ApiQueryParams<"getTicketsV1">["StatusType"], undefined>;
export type TicketVisibility = ApiQueryParams<"getAdminPortfolioTicketsV1", 0>["Filter"];
export type TicketHistoryType = "users" | "addresses";

export const NEW_TICKET_TAB = "new" as const satisfies AdminTicketTabs;
export const IN_PROGRESS_TICKET_TAB = "inProgress" as const satisfies AdminTicketTabs;
export const CLOSED_TICKET_TAB = "closed" as const satisfies AdminTicketTabs;
export const REMINDER_TICKET_TAB = "reminder" as const satisfies AdminTicketTabs;
export const NEW_AND_INPROGRESS_TICKET_TAB = "newAndInProgress" as const satisfies AdminTicketTabs;

export const ticketRatingValues = [-1, 1, 2, 3, 4, 5] as const;
export const ticketVisibilityValues = ["private", "collective"] as const satisfies readonly TicketVisibility[];
export const ticketSortingValues = [
  "unread",
  "newest",
  "oldest",
  "leastRecentActivity",
  "mostRecentActivity",
  "mostRecentReminder",
] as const satisfies readonly TicketSorting[];

export const RESIDENT_OPEN_TICKET_TAB = "open" as const satisfies ResidentTicketTabs;
export const RESIDENT_CLOSED_TICKET_TAB = "closed" as const satisfies ResidentTicketTabs;
export const RESIDENT_RECENT_TICKET_TAB = "recent" as const satisfies ResidentTicketTabs;

export type RepairRequestFilterTypes = "both" | "onlyCollective" | "onlyPrivate";
export const residentTicketTypeValues = [
  "both",
  "onlyCollective",
  "onlyPrivate",
] as const satisfies readonly RepairRequestFilterTypes[];
type ReporterFilterTypes = "mine" | "all";
export const reporterTypeValues = ["all", "mine"] as const satisfies readonly ReporterFilterTypes[];
